import moment from 'moment'
import 'moment/locale/nb'

function datoFormatTekst(date) {
    if (date) {       
        return moment(date).format('LL')
    }
    return '-'
}

function datoFormatMedTidspunktTekst(date) {
    if (date) {       
        return moment(date).format('DD MMM') +" kl."+moment(date).format('HH:mm')
    }
    return '-'
}

function datoFormatDagMnd(date) {
    if (date) {       
        return moment(date).format('DD.MM')
    }
    return '-'
}

function datoFormatMedBareAar(date) {
    if (date) {       
        return moment(date).format('YYYY')
    }
    return '-'
}

function datoFormatTall(date) {
    if (date) {       
        return moment(date).format('DD.MM.YYYY')
    }
    return '-'
}

export{
    datoFormatTekst,
    datoFormatTall,
    datoFormatMedTidspunktTekst,
    datoFormatMedBareAar,
    datoFormatDagMnd
};




// WEBPACK FOOTER //
// ./src/felles/utils/dato-format-tabell.js